import React, { useRef } from 'react'
import { Modal, ModalTitle, Button } from 'src/components/library'

import styles from './styles.module.scss'

export const TermsModal = ({
  hasAcceptedTerms,
  setHasAcceptedTerms,
  isTermsModalOpen,
  setIsTermsModalOpen,
}) => {
  const handleAcceptTerms = () => {
    setHasAcceptedTerms(true)
  }
  const titleRef = useRef()

  return (
    <>
      {!hasAcceptedTerms && !isTermsModalOpen && (
        <div>
          <h2>Sorry, you can't access this</h2>
          <p>
            You must accept the terms and conditions in order to view the
            On-demand content.
          </p>
          <Button variant="primary" onClick={() => setIsTermsModalOpen(true)}>
            View Terms & Conditions
          </Button>
        </div>
      )}
      <Modal
        className={styles.modal}
        isOpen={!hasAcceptedTerms && isTermsModalOpen}
        hasNoCloseButton
        ariaLabel="Please accept the terms and conditions"
        initialFocusRef={titleRef}
      >
        <ModalTitle tabIndex="-1" ref={titleRef}>
          Please accept the terms and conditions
        </ModalTitle>
        <div>
          <p>
            Please consult with your physician before beginning a physical
            activity program. By participating in the exercises depicted in this
            virtual class, you assume all dangers, hazards and risks. The
            exercises depicted in these virtual classes are physically
            demanding. If you are unable to safely perform the exercises
            depicted, please modify them for your own safety or choose a
            different set of exercises. If you participate in the activities
            featured in these virtual classes and you feel discomfort,
            dizziness, nausea, pain or shortness of breath, stop performing the
            exercises immediately. Ensure the area in which you are exercising
            is free of obstacles, other people, pets or items that may create an
            unsafe environment.
          </p>
          <p>
            Some exercises featured in the virtual classes may require exercise
            equipment. Any equipment shown in the classes should only be used as
            demonstrated. You are responsible for inspecting the exercise
            equipment you have chosen to ensure it is not defective or damaged.
            Do not use equipment that is defective or damaged and always use the
            equipment in the prescribed way.
          </p>

          <p>
            Through selecting “I Accept”, I acknowledge that I have read,
            understand, and agree with the terms and conditions and safety
            warnings included above.
          </p>
          <div className={styles.toolbar}>
            <Button variant="primary" onClick={handleAcceptTerms}>
              I accept
            </Button>
          </div>
        </div>
      </Modal>
    </>
  )
}
